import React, { useState } from 'react';
import './Result.css';
import { SearchContext } from '../Provider/Provider';
import config from '../../config.json';
import Pages from '../Pagination/Pagination';

// Use this fragment size if it's not defined in config.json
const MAX_FRAG_SIZE = 400;

function createMarkup(markup) {
  if (markup !== undefined && Array.isArray(markup)) {
    markup = markup[0].substring(0, config.query.highlight.fragment_size ? config.query.highlight.fragment_size : MAX_FRAG_SIZE);
  }
  return {__html: markup};
}

const Result = () => {
  const { results, total } = React.useContext(SearchContext);

  return (
    <div className="Result">
      {results && results.length > 0 &&
        <div className="total-result">
          <p>{ config.query.from + 1 } to { results.length + config.query.from } of { total } results found</p>
        </div>
      }
      {results && results.length > 0 && results.map((value, index) => {
          return (
            <div key={index}>
              <h2><a href={value._source.url}>{value._source.title}</a></h2>
              <div className="result-body">
                {value.highlight && value._source.hasOwnProperty('body')
                  ? <div dangerouslySetInnerHTML={createMarkup(value.highlight.body[0])} />
                  : <div dangerouslySetInnerHTML={createMarkup(value._source.body)} />
                }
              </div>
            </div>
          )
        })
      } 
      { results && results.length === 0 &&
        <p>No results found</p>
      }
      <Pages></Pages>
    </div>
  );
}

export default Result;
